import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { styles } from './css';

export class Nancy extends Lit3formBlock {
  static get characterName() {
    return 'nancy';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid nancy-layout">
          ${this.eyebrowText
            ? html`
                <p class="eyebrow">${unsafeHTML(this.eyebrowText)}</p>
              `
            : html``}
          ${this.headerText
            ? html`
                <h1 class="header">${unsafeHTML(this.headerText)}</h1>
              `
            : html``}
          ${this.descriptionText
            ? html`
                <p class="description">${unsafeHTML(this.descriptionText)}</p>
              `
            : html``}
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }
}
Nancy.defineElement();
